import styled from "styled-components";
import { useAppSelector } from "../../hooks";
import { Collapse, Drawer } from "antd";

const { Panel } = Collapse;

export const HelpDrawer = styled(BaseHelpDrawer)`

  .section {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .subtitle {
    font-weight: 600;
    font-size: var(--font-size-medium);
    color: var(--color-dark);
  }

  .day {
    display: flex;
    justify-content: space-between;
  }

  .secondary-info {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: var(--font-size-small);
  }
`

interface IHelpDrawer {
  className?: string,
  open: boolean,
  onClose: () => void
}

function BaseHelpDrawer({className, open, onClose}: IHelpDrawer) {

  const partner = useAppSelector((state) => state.store)

  return (
    <>
      {
        partner.details &&
        <Drawer className={className} title={"Help"} placement="right" onClose={onClose} open={open}>
          <Collapse>
            <Panel header="My order is incorrect" key="1">
              <p>If some items in your order are missing or incorrect, or if your entire order is wrong, please contact us.</p>
              {
                partner.details.customerContactPhone &&
                <p>Give us a call on <a href={`tel:${partner.details.customerContactPhone}`}>{partner.details.customerContactPhone}</a> &nbsp;
                  {
                    partner.details.customerContactEmail &&
                    <>
                      or send us an email at <a href={`mailto:${partner.details.customerContactEmail}`}>{partner.details.customerContactEmail}</a>
                    </>
                  }
                </p>
              }
            </Panel>
            <Panel header="Order has not arrived" key="2">
              <p>If your order has not yet arrived and has passed the delivery time, please contact us.</p>
              {
                partner.details.customerContactPhone &&
                <p>Give us a call on <a href={`tel:${partner.details.customerContactPhone}`}>{partner.details.customerContactPhone}</a> &nbsp;
                  {
                    partner.details.customerContactEmail &&
                    <>
                      or send us an email at <a href={`mailto:${partner.details.customerContactEmail}`}>{partner.details.customerContactEmail}</a>
                    </>
                  }
                </p>
              }
            </Panel>
            <Panel header="Report an issue" key="3">
              <p>To report an issue with the website, please contact Tifyn Support at <a href = {`mailto: support@tifyn.com.au?subject=Report%20an%20Issue`}>support@tifyn.com.au</a></p>
            </Panel>
          </Collapse>
        </Drawer>
      }
    </>
  )
}